import React from 'react';
import { observer } from 'mobx-react';
import { CapacityPlannerScreen } from '../../screen/CapacityPlanner/Screen';

interface Props { planner: CapacityPlannerScreen; }

@observer
export class AllocationModal extends React.Component<Props> {
    render() {
        const p = this.props.planner;
        if (!p.allocationModalOpen || !p.allocationModalProjectId) return null;
        const allocated = p.allocations.filter(a => (a as any).project?.id === p.allocationModalProjectId).map(a => (a as any).user?.id);
        const available = p.users.filter(u => !allocated.includes(u.id));
        return (
            <div className="cp-modal" data-test-cp-allocation-modal onClick={(e) => { if (e.target === e.currentTarget) p.closeAllocationModal(); }}>
                <div className="cp-modal-content">
                    <h3>Allocate Developer</h3>
                    <div className="form-group">
                        <label>Developer</label>
                        <select value={p.allocationModalDeveloperId || ''} onChange={(e) => p.allocationModalDeveloperId = parseInt(e.target.value)}>
                            {available.map(u => {
                                const uAny = u as any;
                                const hours = p.getDevWeeklyHours(uAny);
                                const pt = p.isPartTime(uAny) ? ` (${hours}h/wk)` : '';
                                return <option key={u.id} value={u.id}>{uAny.fullName}{pt}</option>;
                            })}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Days per Week: <span>{p.allocationModalDays}</span></label>
                        <input type="range" min="0" max="5" step="1" value={p.allocationModalDays}
                            onChange={(e) => p.allocationModalDays = parseInt(e.target.value)} />
                    </div>
                    <div className="cp-modal-actions">
                        <button className="btn btn-secondary" onClick={p.closeAllocationModal}>Cancel</button>
                        <button className="btn btn-primary" onClick={p.confirmAllocation}>Add</button>
                    </div>
                </div>
            </div>
        );
    }
}
